import { render, staticRenderFns } from "./d_external-answers_others.vue?vue&type=template&id=47f0f156"
import script from "./d_external-answers_others.vue?vue&type=script&lang=js"
export * from "./d_external-answers_others.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports